/**
 * Opens Settings at the section that holds the rest of a firm setup item
 * (Case Preparation's divider and page styles, drafting defaults, ...).
 */
import { Settings } from "lucide-react";
import { useState, type FC } from "react";

import { SettingsModal } from "@/components/settings/SettingsModal";
import { Button } from "@/components/ui/button";

type Props = {
  section: string;
  /** The accessible name; also the label unless `iconOnly`. */
  label?: string;
  iconOnly?: boolean;
  testId?: string;
};

export const OpenSettingsButton: FC<Props> = ({
  section,
  label = "Open Settings",
  iconOnly = false,
  testId
}) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        variant="ghost"
        size={iconOnly ? "icon-xs" : "xs"}
        aria-label={iconOnly ? label : undefined}
        title={iconOnly ? label : undefined}
        onClick={() => setOpen(true)}
        data-testid={testId}
      >
        <Settings />
        {iconOnly ? null : label}
      </Button>
      {open ? (
        <SettingsModal open onOpenChange={setOpen} initialSection={section} />
      ) : null}
    </>
  );
};
